export enum Broadcaster {
  MTV= "mtv",
  SANOMA= "sanoma",
}
